import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import CartProductView from "./CartProductView";

@inject("CheckoutStore")
@observer
class CartProducts extends Component {
  get cartItems() {
    const { cartItems } = this.props.CheckoutStore;
    return cartItems;
  }
  render() {
    return (
      <div className="nw-cartproducts">
        {this.cartItems.map(product => (
          <CartProductView.component key={product.skuId} product={product} />
        ))}
      </div>
    );
  }
}

CartProducts.wrappedComponent.propTypes = {
  CheckoutStore: PropTypes.shape({
    cartItems: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export { default as AppliedPromotionsView } from "./AppliedPromotionsView";
export { default as CartProductView } from "./CartProductView";
export * as DeliveryOptions from "./DeliveryOptions";
export { default as OosView } from "./OosView";
export { default as ProductActions } from "./ProductActions";
export { default as ProductDescription } from "./ProductDescription";
export { default as ProductPriceBlock } from "./ProductPriceBlock";
export { default as QuantityView } from "./QuantityView";

const getFinalComponent = component =>
  inject("CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: CartProducts.wrappedComponent,
  component: CartProducts,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/index.js